import { Controller } from "@hotwired/stimulus";

const TOAST_VISIBLE_MS = 4000;

/**
 * Transient bottom toast for customer-initiated cancellations (passkey,
 * wallet connect, payment declined in wallet). Show one with:
 *   document.dispatchEvent(new CustomEvent("toast:show", { detail: { message } }))
 * The screen behind keeps its call to action, so toasts carry no buttons.
 */
export default class extends Controller {
  connect() {
    this.boundShow = this.show.bind(this);
    document.addEventListener("toast:show", this.boundShow);
  }

  disconnect() {
    document.removeEventListener("toast:show", this.boundShow);
    if (this.hideTimer) clearTimeout(this.hideTimer);
  }

  show(event) {
    const message = event.detail?.message;
    if (!message) return;

    if (this.hideTimer) clearTimeout(this.hideTimer);
    this.element.textContent = message;
    this.element.classList.remove("hidden", "opacity-0");
    this.hideTimer = setTimeout(() => this.hide(), TOAST_VISIBLE_MS);
  }

  hide() {
    this.element.classList.add("opacity-0");
    setTimeout(() => this.element.classList.add("hidden"), 300);
  }
}
